import React, { useEffect, useState } from "react";
import {
  AutoSizer,
  CellMeasurer,
  CellMeasurerCache,
  List,
} from "react-virtualized";
import {
  Badge,
  Button,
  Card,
  CardBody,
  CardSubtitle,
  CardText,
  Col,
  Container,
  Form,
  FormGroup,
  Input,
  Jumbotron,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Row,
  Spinner,
} from "reactstrap";
import "./App.css";
import { JSONData } from "./data";
import { internsgipOpportunities } from "./datainternship";

const App = () => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [modal, setModal] = useState(false);
  const [modalData, setModalData] = useState(null);
  const [input, setInput] = useState("");
  const [type, setType] = useState(false);
  const toggle = () => setModal(!modal);

  const cache = new CellMeasurerCache({
    fixedWidth: true,
    defaultHeight: 800,
  });

  useEffect(() => {
    //load data
    if (type) setData(JSONData.reverse());
    if (!type) setData(internsgipOpportunities.reverse());
    setLoading(false);
  }, []);

  const containsObject = (obj, list) => {
    let i;
    for (i = 0; i < list.length; i++) {
      if (list[i]["Name of the student"] === obj["Name of the student"]) {
        return false;
      }
    }

    return true;
  };

  const filter = (keywords) => {
    setInput(keywords.target.value);
    keywords = keywords.target.value.toLowerCase();
    keywords = keywords.replace(",", " ");
    keywords = keywords.split(" ");
    let newData = [];
    if (keywords === "") {
      if (type) setData(JSONData.reverse());
      if (!type) setData(internsgipOpportunities.reverse());
      return;
    }
    keywords.forEach((keyword) => {
      keyword = keyword.trim();
      let auxData = [];
      if (keyword.includes('"')) {
        let newKeyword = keyword.replace(/"/g, "");
        if (type) {
          auxData = JSONData.filter(
            (item) =>
              (item["Preferred domain of internship"]
                .toLowerCase()
                .split(" ")
                .includes(newKeyword) ||
                item["Field of study"]
                  .toLowerCase()
                  .split(" ")
                  .includes(newKeyword) ||
                item["Current Location(With Country)"]
                  .toLowerCase()
                  .split(" ")
                  .includes(newKeyword) ||
                item["Does Remote Internship work for you?"]
                  .toLowerCase()
                  .split(" ")
                  .includes(newKeyword) ||
                item["Anything else you'd like to share?"]
                  .toLowerCase()
                  .split(" ")
                  .includes(newKeyword) ||
                item["Name of the student"]
                  .toLowerCase()
                  .split(" ")
                  .includes(newKeyword) ||
                item["Period of Internship"]
                  .toLowerCase()
                  .split(" ")
                  .includes(newKeyword) ||
                item["Institute Name(College)"]
                  .toLowerCase()
                  .split(" ")
                  .includes(newKeyword) ||
                item.Education.toLowerCase().split(" ").includes(newKeyword)) &&
              containsObject(item, newData)
          );
          newData = [...newData, ...auxData];
          auxData = JSONData.filter(
            (item) =>
              (item["Preferred domain of internship"]
                .toLowerCase()
                .split("/")
                .includes(newKeyword) ||
                item["Field of study"]
                  .toLowerCase()
                  .split("/")
                  .includes(newKeyword) ||
                item["Current Location(With Country)"]
                  .toLowerCase()
                  .split("/")
                  .includes(newKeyword) ||
                item["Does Remote Internship work for you?"]
                  .toLowerCase()
                  .split("/")
                  .includes(newKeyword) ||
                item["Anything else you'd like to share?"]
                  .toLowerCase()
                  .split("/")
                  .includes(newKeyword) ||
                item["Name of the student"]
                  .toLowerCase()
                  .split("/")
                  .includes(newKeyword) ||
                item["Period of Internship"]
                  .toLowerCase()
                  .split("/")
                  .includes(newKeyword) ||
                item["Institute Name(College)"]
                  .toLowerCase()
                  .split("/")
                  .includes(newKeyword) ||
                item.Education.toLowerCase().split("/").includes(newKeyword)) &&
              containsObject(item, newData)
          );
          newData = [...newData, ...auxData];
          auxData = JSONData.filter(
            (item) =>
              (item["Preferred domain of internship"]
                .toLowerCase()
                .split("-")
                .includes(newKeyword) ||
                item["Field of study"]
                  .toLowerCase()
                  .split("-")
                  .includes(newKeyword) ||
                item["Current Location(With Country)"]
                  .toLowerCase()
                  .split("-")
                  .includes(newKeyword) ||
                item["Does Remote Internship work for you?"]
                  .toLowerCase()
                  .split("-")
                  .includes(newKeyword) ||
                item["Anything else you'd like to share?"]
                  .toLowerCase()
                  .split("-")
                  .includes(newKeyword) ||
                item["Name of the student"]
                  .toLowerCase()
                  .split("-")
                  .includes(newKeyword) ||
                item["Period of Internship"]
                  .toLowerCase()
                  .split("-")
                  .includes(newKeyword) ||
                item["Institute Name(College)"]
                  .toLowerCase()
                  .split("-")
                  .includes(newKeyword) ||
                item.Education.toLowerCase().split("-").includes(newKeyword)) &&
              containsObject(item, newData)
          );
          newData = [...newData, ...auxData];
        }
        if (!type) {
          auxData = internsgipOpportunities.filter(
            (item) =>
              (item["Are you open to on-board remote interns?"]
                .toLowerCase()
                .split(" ")
                .includes(newKeyword) ||
                item["Company Name"]
                  .toLowerCase()
                  .split(" ")
                  .includes(newKeyword) ||
                item["Internship Domain"]
                  .toLowerCase()
                  .split(" ")
                  .includes(newKeyword) ||
                item["Website of the company"]
                  .toLowerCase()
                  .split(" ")
                  .includes(newKeyword) ||
                item["Any expectations from the intern?"]
                  .toLowerCase()
                  .split(" ")
                  .includes(newKeyword) ||
                item["Internship Description/Internship Posting Link"]
                  .toLowerCase()
                  .split(" ")
                  .includes(newKeyword) ||
                item["Contact details for the opportunity(Email)"]
                  .toLowerCase()
                  .split(" ")
                  .includes(newKeyword) ||
                item["Anything else you'd like to share?"]
                  .toLowerCase()
                  .split(" ")
                  .includes(newKeyword)) &&
              containsObject(item, newData)
          );
          newData = [...newData, ...auxData];
          auxData = internsgipOpportunities.filter(
            (item) =>
              (item["Are you open to on-board remote interns?"]
                .toLowerCase()
                .split("/")
                .includes(newKeyword) ||
                item["Company Name"]
                  .toLowerCase()
                  .split("/")
                  .includes(newKeyword) ||
                item["Internship Domain"]
                  .toLowerCase()
                  .split("/")
                  .includes(newKeyword) ||
                item["Website of the company"]
                  .toLowerCase()
                  .split("/")
                  .includes(newKeyword) ||
                item["Any expectations from the intern?"]
                  .toLowerCase()
                  .split("/")
                  .includes(newKeyword) ||
                item["Internship Description/Internship Posting Link"]
                  .toLowerCase()
                  .split("/")
                  .includes(newKeyword) ||
                item["Contact details for the opportunity(Email)"]
                  .toLowerCase()
                  .split("/")
                  .includes(newKeyword) ||
                item["Anything else you'd like to share?"]
                  .toLowerCase()
                  .split("/")
                  .includes(newKeyword)) &&
              containsObject(item, newData)
          );
          newData = [...newData, ...auxData];
          auxData = internsgipOpportunities.filter(
            (item) =>
              (item["Are you open to on-board remote interns?"]
                .toLowerCase()
                .split("-")
                .includes(newKeyword) ||
                item["Company Name"]
                  .toLowerCase()
                  .split("-")
                  .includes(newKeyword) ||
                item["Internship Domain"]
                  .toLowerCase()
                  .split("-")
                  .includes(newKeyword) ||
                item["Website of the company"]
                  .toLowerCase()
                  .split("-")
                  .includes(newKeyword) ||
                item["Any expectations from the intern?"]
                  .toLowerCase()
                  .split("-")
                  .includes(newKeyword) ||
                item["Internship Description/Internship Posting Link"]
                  .toLowerCase()
                  .split("-")
                  .includes(newKeyword) ||
                item["Contact details for the opportunity(Email)"]
                  .toLowerCase()
                  .split("-")
                  .includes(newKeyword) ||
                item["Anything else you'd like to share?"]
                  .toLowerCase()
                  .split("-")
                  .includes(newKeyword)) &&
              containsObject(item, newData)
          );
          newData = [...newData, ...auxData];
        }
      } else {
        if (type) {
          newData = JSONData.filter(
            (item) =>
              (item["Preferred domain of internship"]
                .toLowerCase()
                .includes(keyword) ||
                item["Field of study"].toLowerCase().includes(keyword) ||
                item["Current Location(With Country)"]
                  .toLowerCase()
                  .includes(keyword) ||
                item["Does Remote Internship work for you?"]
                  .toLowerCase()
                  .includes(keyword) ||
                item["Anything else you'd like to share?"]
                  .toLowerCase()
                  .includes(keyword) ||
                item["Name of the student"].toLowerCase().includes(keyword) ||
                item["Period of Internship"].toLowerCase().includes(keyword) ||
                item["Institute Name(College)"]
                  .toLowerCase()
                  .includes(keyword) ||
                item.Education.toLowerCase().includes(keyword)) &&
              containsObject(item, newData)
          );
          newData = [...newData, ...auxData];
        }
        if (!type) {
          newData = internsgipOpportunities.filter(
            (item) =>
              (item["Are you open to on-board remote interns?"]
                .toLowerCase()
                .includes(keyword) ||
                item["Company Name"].toLowerCase().includes(keyword) ||
                item["Internship Domain"].toLowerCase().includes(keyword) ||
                item["Website of the company"]
                  .toLowerCase()
                  .includes(keyword) ||
                item["Any expectations from the intern?"]
                  .toLowerCase()
                  .includes(keyword) ||
                item["Internship Description/Internship Posting Link"]
                  .toLowerCase()
                  .includes(keyword) ||
                item["Contact details for the opportunity(Email)"]
                  .toLowerCase()
                  .includes(keyword) ||
                item["Anything else you'd like to share?"]
                  .toLowerCase()
                  .includes(keyword)) &&
              containsObject(item, newData)
          );
          newData = [...newData, ...auxData];
        }
      }
    });
    setData(newData.reverse());
  };

  const handleSubmit = (e) => {
    e.preventDefault();
  };

  const rowRendererStudent = ({
    key, // Unique key within array of rows
    index, // Index of row within collection
    isScrolling, // The List is currently being scrolled
    isVisible, // This row is visible within the List (eg it is not an overscanned row)
    style, // Style object to be applied to row (to position it)
    parent,
  }) => {
    let item = data[index];
    if (!item["Name of the student"]) return <></>;
    return (
      <CellMeasurer
        key={key}
        cache={cache}
        parent={parent}
        columnIndex={0}
        rowIndex={index}
      >
        <Card key={`stuent-${key}`} className="mb-5" style={style}>
          <CardBody style={{ backgroundColor: "#f3f3f3" }}>
            {item["Does Remote Internship work for you?"] && (
              <h5>
                {item["Name of the student"]}{" "}
                {(item["Does Remote Internship work for you?"]
                  .toLowerCase()
                  .split(" ")
                  .includes("yes") ||
                  item["Does Remote Internship work for you?"]
                    .toLowerCase()
                    .split(" ")
                    .includes("avaiable")) && (
                  <Badge color="secondary">Remote</Badge>
                )}
              </h5>
            )}

            <CardSubtitle>
              {item.Education} - {item["Field of study"]}
            </CardSubtitle>
            <h6>College</h6>
            <CardSubtitle>{item["Institute Name(College)"]}</CardSubtitle>
            <h6>Preferred domain of internship</h6>
            <CardSubtitle>
              {item["Preferred domain of internship"]}
            </CardSubtitle>
            <Row>
              <Col>
                <Button
                  onClick={() => {
                    setModalData(item);
                    setModal(!modal);
                  }}
                  color="primary mt-2"
                >
                  See Profile
                </Button>
              </Col>
            </Row>
          </CardBody>
        </Card>
      </CellMeasurer>
    );
  };
  const rowRendererCompany = ({
    key, // Unique key within array of rows
    index, // Index of row within collection
    isScrolling, // The List is currently being scrolled
    isVisible, // This row is visible within the List (eg it is not an overscanned row)
    style, // Style object to be applied to row (to position it)
    parent,
  }) => {
    let item = data[index];
    if (!item["Company Name"]) return <></>;
    return (
      <CellMeasurer
        key={key}
        cache={cache}
        parent={parent}
        columnIndex={0}
        rowIndex={index}
      >
        <Card key={`stuent-${key}`} className="mb-5" style={style}>
          <CardBody style={{ backgroundColor: "#f3f3f3" }}>
            {item["Are you open to on-board remote interns?"] && (
              <h5>
                {item["Company Name"]}{" "}
                {(item["Are you open to on-board remote interns?"]
                  .toLowerCase()
                  .split(" ")
                  .includes("yes") ||
                  item["Are you open to on-board remote interns?"]
                    .toLowerCase()
                    .split(" ")
                    .includes("avaiable")) && (
                  <Badge color="secondary">Remote</Badge>
                )}
              </h5>
            )}
            <h6>Domain</h6>
            <CardSubtitle>{item["Internship Domain"]}</CardSubtitle>
            <h6>Duration of the internship (Months)</h6>
            <CardSubtitle>
              {item["Duration of the internship (Months)"]}
            </CardSubtitle>
            <h6>Are you open to on-board remote interns?</h6>
            <CardSubtitle>
              {item["Are you open to on-board remote interns?"]}
            </CardSubtitle>
            <Row>
              <Col>
                <Button
                  onClick={() => {
                    setModalData(item);
                    setModal(!modal);
                  }}
                  color="primary mt-2"
                >
                  See Internship
                </Button>
              </Col>
            </Row>
          </CardBody>
        </Card>
      </CellMeasurer>
    );
  };

  if (loading)
    return (
      <div className="hero">
        <Spinner />
      </div>
    );

  return (
    <div fluid>
      <Jumbotron fluid>
        <Container fluid>
          <h1 className="display-3 text-center">Career Circle</h1>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
            }}
          >
            <p className="lead  text-center  mr-2">
              Student ?{" "}
              <a href="http://tiny.cc/lmggmz" about="_blank">
                Click here to fill the form
              </a>
            </p>
          </div>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
            }}
          >
            <p className="lead  text-center  mr-2">
              Organisation ?{" "}
              <a href="http://tiny.cc/0lggmz" about="_blank">
                Click here to post a job
              </a>
            </p>
          </div>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
            }}
          >
            <p className="lead text-center">
              Want to connect with me ?{" "}
              <a
                className="ml-2"
                href="https://www.linkedin.com/in/tanuja-nailwal/"
              >
                <i class="fab fa-linkedin-in  mr-2"></i>Tanuja Nailwal
              </a>
              <span className="ml-2">( tanujanailwal@gmail.com )</span>
            </p>
          </div>

          <div className="alert alert-danger" role="alert">
            <p className="lead text-center">For Students</p>
            <p className="lead text-center">
              If anyone tries to contact you with spammy/marketing emails,
              please get back to me with the details. This database is prepared
              to help you and not for the companies to use it for their personal
              benefits. Feel free to reach out to me in case you think that your
              data is being used for the purpose you didn't fill it for.
            </p>
          </div>
          <div className="alert alert-success" role="alert">
            <p className="lead text-center">
              Developed by
              <a className="ml-2" href="https://www.linkedin.com/in/sunnydhama">
                <i class="fab fa-linkedin-in  mr-2"></i>Sunny Dhama
              </a>
              <span className="ml-2 mr-1">Website</span>
              <a className="ml-2" href="https://sunnydhama.com">
                <i class="fas fa-link"></i>
              </a>
            </p>
          </div>
        </Container>
      </Jumbotron>
      <Container className="justify-content-center" fluid>
        <h6 className="text-center">Select listings</h6>
        <Row className="d-flex justify-content-center mb-4 mt-4">
          <Col className="d-flex justify-content-around">
            <Button
              onClick={() => {
                setData(internsgipOpportunities);
                setType(false);
              }}
              color={`${!type ? "primary" : "secondary"} mt-2`}
            >
              Internships
            </Button>

            <Button
              onClick={() => {
                setType(true);
                setData(JSONData);
              }}
              color={`${!type ? "secondary" : "primary"} mt-2`}
            >
              Students
            </Button>
          </Col>
        </Row>
        <Row>
          <Col>
            <Form onSubmit={handleSubmit}>
              <FormGroup>
                <h5>Search for keywords</h5>
                <Input
                  type="text"
                  name="keywords"
                  id="keywords"
                  placeholder='react, "IIT" - exact match, android, ios, iit, biotech, technical'
                  onChange={filter}
                />
              </FormGroup>
            </Form>
          </Col>
        </Row>
        <Row>
          <Col>
            <h6 className="mt-2 mb-2">{data.length} - results found</h6>
          </Col>
        </Row>
        {modalData && type && (
          <Modal isOpen={modal} toggle={toggle}>
            <ModalHeader toggle={toggle}>
              {modalData["Name of the student"]}
            </ModalHeader>
            <ModalBody>
              <Card className="mb-2">
                <CardBody>
                  {modalData["Does Remote Internship work for you?"] && (
                    <h5>
                      {modalData["Name of the student"]}{" "}
                      {(modalData["Does Remote Internship work for you?"]
                        .toLowerCase()
                        .split(" ")
                        .includes("yes") ||
                        modalData["Does Remote Internship work for you?"]
                          .toLowerCase()
                          .split(" ")
                          .includes("avaiable")) && (
                        <Badge color="secondary">Remote</Badge>
                      )}
                    </h5>
                  )}

                  <CardSubtitle>
                    {modalData.Education} - {modalData["Field of study"]}
                  </CardSubtitle>
                  <h6>College</h6>
                  <CardSubtitle>
                    {modalData["Institute Name(College)"]}
                  </CardSubtitle>
                  <h6>Preferred domain of internship</h6>
                  <CardSubtitle>
                    {modalData["Preferred domain of internship"]}
                  </CardSubtitle>

                  <h6>Period of Internship</h6>
                  <CardSubtitle>
                    {modalData["Period of Internship"]}
                  </CardSubtitle>
                  <h6>Current Location</h6>
                  <CardSubtitle>
                    {modalData["Current Location(With Country)"]}
                  </CardSubtitle>
                  <h6>Does Remote Internship work for you?</h6>
                  <CardSubtitle>
                    {modalData["Does Remote Internship work for you?"]}
                  </CardSubtitle>
                  <h6>Other Details</h6>
                  <CardText>
                    {modalData["Anything else you'd like to share?"]}
                  </CardText>
                </CardBody>
              </Card>
            </ModalBody>
            <ModalFooter style={{ display: "flex", flexDirection: "column" }}>
              {modalData["LinkedIn profile link"].includes("https://") && (
                <Button
                  className="mr-4 mt-4 w-50"
                  onClick={() =>
                    window.open(modalData["LinkedIn profile link"], "_blank")
                  }
                  color="primary"
                >
                  <i class="fab fa-linkedin-in"></i> LinkedIn
                </Button>
              )}
              {modalData["Link to Resume(Google Drive/Dropbox)"].includes(
                "https://"
              ) && (
                <Button
                  className="mr-4 mt-4 w-50"
                  onClick={() =>
                    window.open(
                      modalData["Link to Resume(Google Drive/Dropbox)"],
                      "_blank"
                    )
                  }
                  color="link"
                >
                  <i class="fas fa-file"></i> Resume
                </Button>
              )}
              {modalData["Contact Details (Email)"].includes("@") && (
                <Button
                  className="mr-4 mt-4 w-50"
                  onClick={() => {
                    var mail = `mailto:${modalData["Contact Details (Email)"]}`;
                    var a = document.createElement("a");
                    a.href = mail;
                    a.click();
                  }}
                  color="secondary"
                >
                  <i class="fas fa-envelope"></i> Email
                </Button>
              )}
            </ModalFooter>
          </Modal>
        )}
        {modalData && !type && (
          <Modal isOpen={modal} toggle={toggle}>
            <ModalHeader toggle={toggle}>
              {modalData["Company Name"]}
            </ModalHeader>
            <ModalBody>
              <Card className="mb-2">
                <CardBody>
                  {modalData["Are you open to on-board remote interns?"] && (
                    <h5>
                      {modalData["Company Name"]}{" "}
                      {(modalData["Are you open to on-board remote interns?"]
                        .toLowerCase()
                        .split(" ")
                        .includes("yes") ||
                        modalData["Are you open to on-board remote interns?"]
                          .toLowerCase()
                          .split(" ")
                          .includes("avaiable")) && (
                        <Badge color="secondary">Remote</Badge>
                      )}
                    </h5>
                  )}

                  <h6>Domain</h6>
                  <CardSubtitle>{modalData["Internship Domain"]}</CardSubtitle>
                  <h6>Duration of the internship (Months)</h6>
                  <CardSubtitle>
                    {modalData["Duration of the internship (Months)"]}
                  </CardSubtitle>
                  <h6>Are you open to on-board remote interns?</h6>
                  <CardSubtitle>
                    {modalData["Are you open to on-board remote interns?"]}
                  </CardSubtitle>
                  <h6>Period of Internship</h6>
                  <CardSubtitle>
                    {modalData["Period of Internship"]}
                  </CardSubtitle>
                  <h6>Any expectations from the intern?</h6>
                  <CardSubtitle>
                    {modalData["Any expectations from the intern?"]}
                  </CardSubtitle>
                  <h6>Internship Description/Internship Posting Link</h6>
                  {modalData[
                    "Internship Description/Internship Posting Link"
                  ].includes(".com") ? (
                    <Button
                      className="mr-4 mt-4 w-50"
                      onClick={() => {
                        window.open(
                          modalData[
                            "Internship Description/Internship Posting Link"
                          ].trim(),
                          "_blank"
                        );
                      }}
                      color="primary"
                    >
                      <i class="fas fa-link"></i> Visit Website
                    </Button>
                  ) : (
                    <CardSubtitle>
                      {
                        modalData[
                          "Internship Description/Internship Posting Link"
                        ]
                      }
                    </CardSubtitle>
                  )}
                </CardBody>
              </Card>
            </ModalBody>
            <ModalFooter style={{ display: "flex", flexDirection: "column" }}>
              {modalData["Contact details for the opportunity(Email)"].includes(
                "@"
              ) ? (
                <Button
                  className="mr-4 mt-4 w-50"
                  onClick={() => {
                    var mail = `mailto:${modalData["Contact details for the opportunity(Email)"]}`;
                    var a = document.createElement("a");
                    a.href = mail;
                    a.click();
                  }}
                  color="secondary"
                >
                  <i class="fas fa-envelope"></i> Email
                </Button>
              ) : (
                <CardSubtitle>
                  {modalData["Contact details for the opportunity(Email)"]}
                </CardSubtitle>
              )}
            </ModalFooter>
          </Modal>
        )}

        {input.length !== 0 && (
          <div style={{ overflow: "hidden" }}>
            <AutoSizer style={{ height: "80vh", width: "100vw" }}>
              {({ width, height }) => {
                return (
                  <List
                    width={width}
                    height={height}
                    rowCount={data.length}
                    deferredMeasurementCache={cache}
                    rowHeight={cache.rowHeight}
                    rowRenderer={type ? rowRendererStudent : rowRendererCompany}
                    overscanRowCount={10}
                  />
                );
              }}
            </AutoSizer>
          </div>
        )}
        {input.length === 0 && (
          <div>
            <h5 className="text-center">Use keywords to search for results</h5>
          </div>
        )}
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <h2 className="text-center mt-4 mb-4">A little insight</h2>

          <Row
            style={{
              width: "100vw",
            }}
          >
            <Col
              xs={3}
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <Button
                className=" mt-4 text-center"
                onClick={() =>
                  window.open(
                    "https://www.linkedin.com/posts/squadplatform_trying-to-find-an-internship-for-summer-2020-activity-6667031929893851136-5HVh",
                    "_blank"
                  )
                }
                color="link"
              >
                Coverage of the initiative{" "}
              </Button>
            </Col>
            <Col
              xs={3}
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <Button
                className=" mt-4 text-center"
                onClick={() =>
                  window.open(
                    "https://www.linkedin.com/in/tanuja-nailwal/",
                    "_blank"
                  )
                }
                color="link"
              >
                LinkedIn Community{" "}
              </Button>
            </Col>
            <Col
              xs={3}
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <Button
                className=" mt-4 text-center"
                onClick={() =>
                  window.open(
                    "https://www.linkedin.com/posts/tanuja-nailwal_internships-students-opporunity-activity-6653438250667077632-6TH9",
                    "_blank"
                  )
                }
                color="link"
              >
                Background
              </Button>
            </Col>
            <Col
              xs={3}
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <Button
                className=" mt-4 text-center"
                onClick={() =>
                  window.open(
                    "https://www.linkedin.com/posts/tanuja-nailwal_linkedincommunity-summerinternships-students-activity-6654023256435195904-cA8Y",
                    "_blank"
                  )
                }
                color="link"
              >
                Transparency
              </Button>
            </Col>
          </Row>
        </div>
      </Container>
    </div>
  );
};

export default App;
